<script lang="ts" setup>
  import { onMounted, toRefs } from 'vue'
  import { SetPageTitle } from '@/helpers/router'

  interface Props {
    title: string
    window?: boolean
  }

  const props = withDefaults(defineProps<Props>(), { window: true })
  const { title, window } = toRefs(props)

  if (window.value)
    onMounted(() => {
      SetPageTitle(title.value)
    })
</script>

<template>
  <h2 class="text-xl font-semibold text-primary-text my-2 text-center md:text-left">
    {{ title }}
  </h2>
</template>
